import instance from '../../api/instance'
const path = '/wv/faq_ratings'

export default {
  async create(host, faq_rating) {
    let body = {faq_rating}
    return instance(window.config['application_host']).post(host + path, body)
  },
  async markRatingSeen(visible) {
    return await instance(window.config['application_host']).get(path + `/mark_rating_seen?visible=${visible}`)
  },
}
